import { render, staticRenderFns } from "./portfolio-review-edit-notes.vue?vue&type=template&id=5065bbc0&scoped=true&"
import script from "./portfolio-review-edit-notes.vue?vue&type=script&lang=js&"
export * from "./portfolio-review-edit-notes.vue?vue&type=script&lang=js&"
import style0 from "./portfolio-review-edit-notes.vue?vue&type=style&index=0&id=5065bbc0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5065bbc0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VChip,VDivider,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5065bbc0')) {
      api.createRecord('5065bbc0', component.options)
    } else {
      api.reload('5065bbc0', component.options)
    }
    module.hot.accept("./portfolio-review-edit-notes.vue?vue&type=template&id=5065bbc0&scoped=true&", function () {
      api.rerender('5065bbc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/portfolio-review/modal/edit-notes/portfolio-review-edit-notes.vue"
export default component.exports